<template>
  <b-form-group
    id="fieldset-1"
    label="コレクション選択"
  >
    <b-form-select
      v-model="model"
      :options="items">
    </b-form-select>
  </b-form-group>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'settings/apiTest',
      attribute: 'collection'
    }
  },

  computed: {
    items () {
      return this.$store.getters[`${this.modelName}/getAttr`]('collections')
    },

    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`]('model')
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
        this.$store.dispatch(`${this.modelName}/getItems`)
      }
    }
  }
}
</script>
